import React from 'react';
import './lower-extremity-prosthetics.css';
import { Link } from "react-router-dom";

function LowerExtremityProsthetics() {
  const prostheticTypes = [
    {
      id: "above-knee",
      title: "Above-Knee Prosthetics",
      description: "Custom-designed artificial limbs for individuals with transfemoral amputations, featuring advanced knee mechanisms for natural gait patterns.",
      features: ["Microprocessor knees", "Suction suspension systems", "Weight-bearing comfort"]
    },
    {
      id: "below-knee",
      title: "Below-Knee Prosthetics",
      description: "Precision-engineered solutions for transtibial amputations, focusing on mobility, stability, and energy return.",
      features: ["Dynamic response feet", "Patellar tendon bearing", "Shock absorption"]
    },
    {
      id: "hip-disarticulation",
      title: "Hip Disarticulation",
      description: "Specialized prosthetic systems for individuals with hip-level amputations, combining advanced mechanics with lightweight materials.",
      features: ["Canadian-style sockets", "Hydraulic hip joints", "Custom suspension"]
    },
    {
      id: "partial-foot",
      title: "Partial Foot Solutions",
      description: "Innovative devices for partial foot amputations, preserving natural function while providing necessary support.",
      features: ["Toe fillers", "Carbon fiber plates", "Custom arch support"]
    }
  ];

  const benefits = [
    {
      id: "mobility",
      title: "Restored Mobility",
      description: "Regain independence with custom-fitted prosthetics designed for your specific lifestyle and activity level."
    },
    {
      id: "comfort",
      title: "Superior Comfort",
      description: "Advanced socket designs and suspension systems ensure all-day comfort without compromising functionality."
    },
    {
      id: "durability",
      title: "Long-Lasting Durability",
      description: "High-quality materials and precision engineering provide reliable performance for years to come."
    },
    {
      id: "natural-gait",
      title: "Natural Gait Pattern",
      description: "Microprocessor and hydraulic components work together to create a smooth, natural walking experience."
    }
  ];

  const processSteps = [
    {
      id: "step1",
      number: "01",
      title: "Initial Consultation",
      description: "Comprehensive evaluation of your needs, lifestyle, and medical history by our specialist team."
    },
    {
      id: "step2",
      number: "02",
      title: "Precision Measurement",
      description: "Advanced 3D scanning and casting techniques to ensure perfect fit and alignment."
    },
    {
      id: "step3",
      number: "03",
      title: "Custom Fabrication",
      description: "Skilled craftsmanship using state-of-the-art materials and components."
    },
    {
      id: "step4",
      number: "04",
      title: "Fitting & Training",
      description: "Comprehensive fitting sessions and gait training for optimal adaptation."
    }
  ];

  const technologies = [
    { id: "microprocessor", name: "Microprocessor Knees" },
    { id: "carbon-fiber", name: "Carbon Fiber Feet" },
    { id: "hydraulic", name: "Hydraulic Ankles" },
    { id: "vacuum", name: "Vacuum Suspension" },
    { id: "silicon", name: "Silicon Liners" },
    { id: "3d-scanning", name: "3D Scanning Technology" }
  ];

  return (
    <div className="lower-extremity-prosthetics-page">

      {/* Hero Section */}
      <section className="lep-hero-section">
        <div className="lep-hero-overlay">
          <div className="lep-hero-container">
            <div className="lep-hero-content">
              <span className="lep-hero-badge">Lower Extremity Prosthetics</span>
              <h1 className="lep-hero-title">
                Advanced Solutions for <span className="lep-hero-highlight">Lower Limb Mobility</span>
              </h1>
              <p className="lep-hero-subtitle">
                Custom-engineered prosthetic devices designed to restore natural movement, 
                provide lasting comfort, and help you return to the activities you love.
              </p>
              <div className="lep-hero-buttons">
                <Link to="/contactus" className="lep-btn lep-btn-primary">Schedule Consultation</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="lep-intro-section">
        <div className="lep-container">
          <div className="lep-intro-grid">
            <div className="lep-intro-content">
              <span className="lep-section-badge">Overview</span>
              <h2 className="lep-intro-heading">Comprehensive Lower Extremity Solutions</h2>
              <p className="lep-intro-text">
                At Southern Rehab Care, we understand that losing a limb or being born with a limb 
                difference presents unique challenges. Our lower extremity prosthetics are designed 
                not just to replace function, but to enhance your quality of life.
              </p>
              <p className="lep-intro-text">
                Using the latest advances in prosthetic technology, including microprocessor knees, 
                energy-storing feet, and lightweight materials, we create devices that feel like a 
                natural extension of your body.
              </p>
              <div className="lep-intro-stats">
                <div className="lep-intro-stat">
                  <span className="lep-intro-stat-number">500+</span>
                  <span className="lep-intro-stat-label">Patients Fitted</span>
                </div>
                <div className="lep-intro-stat">
                  <span className="lep-intro-stat-number">100%</span>
                  <span className="lep-intro-stat-label">Success Rate</span>
                </div>
                <div className="lep-intro-stat">
                  <span className="lep-intro-stat-number">15+</span>
                  <span className="lep-intro-stat-label">Years Experience</span>
                </div>
              </div>
            </div>
            <div className="lep-intro-image-wrapper">
              <img src="/lower-extremity-prosthetic.png" alt="Lower Extremity Prosthetic" className="lep-intro-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Prosthetic Types Section */}
      <section className="lep-types-section">
        <div className="lep-container">
          <div className="lep-section-header">
            <span className="lep-section-badge">Our Solutions</span>
            <h2 className="lep-section-heading">Types of Lower Extremity Prosthetics</h2>
            <p className="lep-section-subheading">Customized solutions for every level of amputation</p>
          </div>

          <div className='lower-Extremity-images'>
            <img src='/low66.jpg' className='image-lower-extremity' />
            <img src='/low7.jpg' className='image-lower-extremity'/>
            <img src='/low8.jpg' className='image-lower-extremity'/>
            <img src='/low9.jpg' className='image-lower-extremity'/>
            {/* <img src='/low6.jpg' className='image-lower-extremity' /> */}
           
          </div>

          <div className='lower-Extremity-images'>
             <img src='/low10.jpg' className='image-lower-extremity'/>
            <img src='/lower2.jpg' className='image-lower-extremity'/>
            <img src='/lower4.jpg' className='image-lower-extremity'/>
            <img src='/lower8.jpg' className='image-lower-extremity'/>
          </div>


          <div className="lep-section-header">
    
            <h2 className="lep-section-heading">Types of Lower Extremity Orthotics</h2>
            <p className="lep-section-subheading">Customized solutions for every level of amputation</p>
          </div>

            <div className='lower-Extremity-images'>
            <img src='/lower3.jpg' className='image-lower-extremity'/>
            <img src='/lower5.jpg' className='image-lower-extremity' />
            <img src='/lower6.jpg' className='image-lower-extremity'/>
            <img src='/lower7.jpg' className='image-lower-extremity'/>
            </div>





          <div className="lep-types-grid">
            {prostheticTypes.map((type) => (
              <div key={type.id} className="lep-type-card">
                <h3 className="lep-type-title">{type.title}</h3>
                <p className="lep-type-description">{type.description}</p>
                <ul className="lep-type-features">
                  {type.features.map((feature, index) => (
                    <li key={index} className="lep-type-feature">
                      <span className="lep-type-feature-dot"></span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="lep-benefits-section">
        <div className="lep-container">
          <div className="lep-section-header">
            <span className="lep-section-badge lep-section-badge-light">Why Choose Us</span>
            <h2 className="lep-section-heading lep-section-heading-light">Benefits of Our Prosthetics</h2>
            <p className="lep-section-subheading lep-section-subheading-light">Engineered for your active lifestyle</p>
          </div>
          <div className="lep-benefits-grid">
            {benefits.map((benefit) => (
              <div key={benefit.id} className="lep-benefit-card">
                <h3 className="lep-benefit-title">{benefit.title}</h3>
                <p className="lep-benefit-description">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="lep-process-section">
        <div className="lep-container">
          <div className="lep-section-header">
            <span className="lep-section-badge">Our Process</span>
            <h2 className="lep-section-heading">Your Journey to Mobility</h2>
            <p className="lep-section-subheading">A step-by-step approach to your new prosthetic</p>
          </div>
          <div className="lep-process-grid">
            {processSteps.map((step) => (
              <div key={step.id} className="lep-process-card">
                <div className="lep-process-number">{step.number}</div>
                <h3 className="lep-process-title">{step.title}</h3>
                <p className="lep-process-description">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technology Section */}
      <section className="lep-tech-section">
        <div className="lep-container">
          <div className="lep-tech-grid">
            <div className="lep-tech-content">
              <span className="lep-tech-badge">Advanced Technology</span>
              <h2 className="lep-tech-heading">Cutting-Edge Components & Materials</h2>
              <p className="lep-tech-text">
                We utilize the latest advancements in prosthetic technology, from microprocessor-controlled 
                knees to carbon fiber energy-storing feet, ensuring you receive the most sophisticated 
                solutions available today.
              </p>
              <div className="lep-tech-tags">
                {technologies.map((tech) => (
                  <span key={tech.id} className="lep-tech-tag">{tech.name}</span>
                ))}
              </div>
            </div>
            <div className="lep-tech-image-wrapper">
              <img src="/Microprocessor Knees.png" alt="Prosthetic Technology" className="lep-tech-image" />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="lep-faq-section">
        <div className="lep-container">
          <div className="lep-section-header">
            <span className="lep-section-badge">FAQ</span>
            <h2 className="lep-section-heading">Frequently Asked Questions</h2>
            <p className="lep-section-subheading">Common questions about lower extremity prosthetics</p>
          </div>
          <div className="lep-faq-grid">
            <div className="lep-faq-item">
              <h3 className="lep-faq-question">How long does it take to get a prosthetic?</h3>
              <p className="lep-faq-answer">The entire process from initial consultation to final fitting typically takes 4-6 weeks, depending on the complexity of your needs and component availability.</p>
            </div>
            <div className="lep-faq-item">
              <h3 className="lep-faq-question">Will insurance cover my prosthetic?</h3>
              <p className="lep-faq-answer">Most insurance plans, including government healthcare, provide coverage for prosthetic devices. Our team will help verify your benefits.</p>
            </div>
            <div className="lep-faq-item">
              <h3 className="lep-faq-question">How long will my prosthetic last?</h3>
              <p className="lep-faq-answer">With proper care, a prosthetic device typically lasts 3-5 years. However, components may need replacement or adjustment based on wear and activity level.</p>
            </div>
            <div className="lep-faq-item">
              <h3 className="lep-faq-question">Can I play sports with a prosthetic?</h3>
              <p className="lep-faq-answer">Yes! Many of our patients lead active lifestyles. We offer specialized activity-specific components for running, swimming, and various sports.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="lep-cta-section">
        <div className="lep-container">
          <div className="lep-cta-content">
            <h2 className="lep-cta-heading">Ready to Take the Next Step?</h2>
            <p className="lep-cta-subheading">Schedule a consultation with our lower extremity specialists today</p>
            <div className="lep-cta-buttons">
              <Link to="/contactus" className="lep-btn lep-btn-primary">Contact Us</Link>
              <Link to="/contactus" className="lep-btn lep-btn-secondary-light">Book Appointment</Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}

export default LowerExtremityProsthetics;